import { render } from "./flowHistory.vue?vue&type=template&id=e639bef2"
import script from "./flowHistory.vue?vue&type=script&lang=js"
export * from "./flowHistory.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__